import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./styles.css";
import { db } from "../../assets/firebase/firebaseconfig";
import { ref, get, child } from "firebase/database";
import Test from "../Test";
import { auth } from "../../assets/firebase/firebaseconfig";
import { signInWithEmailAndPassword } from "firebase/auth";
import { Helmet } from "react-helmet";
const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
 const [installPrompt, setInstallPrompt] = useState(null);

  useEffect(() => {
    // 1. Đăng ký Service Worker để trình duyệt công nhận là App
    if ("serviceWorker" in navigator) {
      // Thêm dấu / ở trước để đảm bảo nó tìm đúng file trong thư mục public
      navigator.serviceWorker
        .register("/service-worker.js")
        .then(() => console.log("SW đã chạy!"))
        .catch((err) => console.log("SW bị lỗi đường dẫn:", err));
    }

    // 2. Lắng nghe sự kiện sẵn sàng cài đặt
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
      console.log("PWA: Sẵn sàng cài đặt!");
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstall);
    return () =>
      window.removeEventListener("beforeinstallprompt", handleBeforeInstall);
  }, []);

  const handleInstallClick = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === "accepted") {
      setInstallPrompt(null);
    }
  };
  console.log('iii', installPrompt);
  
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    const cleanUser = username.trim().toLowerCase();
    console.log("Đang tìm tài khoản:", cleanUser); // Dòng này để kiểm tra trong Console

    try {
      const dbRef = ref(db);
      // Kiểm tra đường dẫn này có khớp với tên nút trên Firebase không
      const snapshot = await get(child(dbRef, `user_admin/${cleanUser}`));

      if (snapshot.exists()) {
        const passwordInDb = snapshot.val();
        console.log("Mật khẩu trên Firebase là:", passwordInDb);

        if (String(passwordInDb) === String(password)) {
          // Ép kiểu về chuỗi để so sánh cho chắc
          alert("Thành công!");
          navigate("/admin/dashboard");
        } else {
          alert("Sai mật khẩu!");
        }
      } else {
        alert("Không tìm thấy username: " + cleanUser);
      }
    } catch (error) {
      alert("Lỗi: " + error.message);
    }
  };

  return (
    <div className="admin-login-wrapper">
    <Helmet>
  <title key="admin-login">Hệ Thống Quản Trị - Habako</title>
  <meta name="robots" content="noindex, nofollow" />
</Helmet>
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h2>Quản Trị Hệ Thống</h2>
          <p>Vui lòng đăng nhập để tiếp tục</p>
        </div>

        <form onSubmit={handleLogin} className="admin-form">
          <div className="form-group">
            <label>Tên đăng nhập</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Nhập username..."
              required
            />
          </div>

          <div className="form-group">
            <label>Mật khẩu</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Nhập mật khẩu..."
              required
            />
          </div>

          <div className="form-options">
            <Link
              to="/admin/forgot-password"
              title="Chức năng này sẽ cập nhật sau"
            >
              Quên mật khẩu?
            </Link>
          </div>

          <button type="submit" className="login-button">
            Đăng Nhập
          </button>
        </form>

        <div className="admin-footer">
          <button onClick={() => navigate("/")} className="back-home-link">
            ← Quay lại trang chủ
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
